import script from "./TranscoderSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscoderSettings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__